import { useTranslation } from "react-i18next";
import CheckIcon from "../../../icons/checkIcon";

const CustomsClearance = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className="font-semibold text-[32px] text-center pb-10 ">
            {t("customClearance")}
          </h1>
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("ensuringEaseAndSpeed")}
          </h2>
          <p className=" text-[18px]">{t("customsClearanceProcess")}</p>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/customClearance1.jpg"
            alt="customs clearance 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/customClearance2.jpg"
            alt="customs clearance 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/customClearance3.jpg"
            alt="customs clearance 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/customClearance2.jpg"
            alt="customs clearance 4"
          />
        </section>
        {/* definition section */}
        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("customsDefinition")}
          </h2>
          <h3 className="text-lg text-mainBlue">{t("whatIsCustoms?")}</h3>
          <p>{t("processOfSubmitting")}</p>
          {/* Differences in Customs Clearance*/}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("differencesInCustoms")}
          </h3>
          <section className="text-lg">
            <h2 className="text-mainBlue">{t("aEurope")}</h2>
            <p>{t("unifiedSystemInEU")}</p>
            <h2 className="text-mainBlue">{t("bRoundTheWorld")}</h2>
            <p>{t("aroundTheWorldCustomsSystem")}</p>
            <h2 className="text-mainBlue"> {t("cMiddleEast")}</h2>
            <p>{t("diverseCustomsSystem")}</p>
          </section>

          {/* megtlogistics’ Role */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("megtlogisticsRole")}
          </h3>
          <h4 className=" text-mainBlue">{t("megtlogisticsProvides")}</h4>
          <div className="space-y-2">
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("coordinationWithCustoms")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("documentVerification")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("customsConsultancy")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("continuousMonitoring")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("tariffAndCostTransparency")}</span>
            </p>
          </div>
          {/* Key Considerations */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("keyConsiderations")}
          </h3>
          <p>{t("correctClassification")}</p>
          <p>{t("complianceLocalRegulations")}</p>
          <p>{t("leveragingExpertServices")}</p>
          {/* Conclusion */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">{t("conclusion")}</h3>
          <p>{t("customsClearanceCriticalStep")}</p>
        </section>
      </div>
    </main>
  );
};

export default CustomsClearance;
